var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.2414,
    height: 40.8276,
    rx: 12,
    fill: "#1F83C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6553 20.0771H20.5437V33.1035V33.3185H20.7587H26.4829H26.6979V33.1035V20.0771H30.3725H30.5635L30.586 19.8874L31.1102 15.4736L31.1387 15.2333H30.8967H26.6979V12.8207C26.6979 12.2271 26.7684 11.8645 26.9968 11.6341C27.2271 11.4017 27.6736 11.2495 28.5863 11.2495H30.8967H31.1117V11.0345V6.6207V6.4057H30.8967H27.0415C24.6514 6.4057 23.0122 6.95304 21.9746 8.01808C20.9377 9.0823 20.5437 10.6204 20.5437 12.5035V15.2333H17.6553H17.4403V15.4483V19.8621V20.0771H17.6553ZM27.0415 7.93915H29.5782V9.71604H28.5863C27.765 9.71604 26.601 9.7846 25.8683 10.5936L25.8679 10.5941C25.2541 11.2761 25.1644 12.1105 25.1644 12.8138V15.4069V16.5517V16.7667H25.3794H26.5587H29.4132L29.2022 18.5436H26.5587H25.3794H25.1644V18.7586V19.8276V31.785H22.0772V19.8276V18.7586V18.5436H21.8622H20.8346H18.9737V16.7667H20.8346H21.8622H22.0772V16.5517V15.4138V12.5035C22.0772 10.8402 22.4444 9.75354 23.0868 9.07935L23.0868 9.07936L23.0883 9.07774C23.7968 8.31864 25.0896 7.93915 27.0415 7.93915Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.301f1f8bfd160a2b97b22b2badefc5a0.svg";
export { ForwardRef as ReactComponent };